import { QueryClient } from '@tanstack/react-query';
import { DEFAULT_GC_TIME_MS, DEFAULT_STALE_TIME_MS } from '@hetivo/hetivo-lib-front-utils';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: DEFAULT_GC_TIME_MS,
      retry: false,
      staleTime: DEFAULT_STALE_TIME_MS,
    },
  },
});
